module.exports = __webpack_public_path__ + "img/expression5.a6e9f8ff.png";